/**
 * @copyright
 * (c) 2026 netTrek GmbH & Co. KG
 *
 * Minimal CBOR encoder — only what's needed to build a COSE Sig_structure:
 * arrays, byte strings, text strings and unsigned integers.
 */

function head (major: number, n: number): Uint8Array {
    if (n < 24) return new Uint8Array([(major << 5) | n])
    if (n < 0x100) return new Uint8Array([(major << 5) | 24, n])
    if (n < 0x10000) return new Uint8Array([(major << 5) | 25, n >> 8, n & 0xff])
    if (n < 0x100000000) return new Uint8Array([(major << 5) | 26, (n >>> 24) & 0xff, (n >> 16) & 0xff, (n >> 8) & 0xff, n & 0xff])
    // 64-bit length
    const hi = Math.floor(n / 0x100000000)
    const lo = n >>> 0
    return new Uint8Array([(major << 5) | 27, (hi >> 24) & 0xff, (hi >> 16) & 0xff, (hi >> 8) & 0xff, hi & 0xff, (lo >>> 24) & 0xff, (lo >> 16) & 0xff, (lo >> 8) & 0xff, lo & 0xff])
}

function concat (parts: Uint8Array[]): Uint8Array {
    let len = 0
    for (const p of parts) len += p.length
    const out = new Uint8Array(len)
    let off = 0
    for (const p of parts) { out.set(p, off); off += p.length }
    return out
}

const textEncoder = new TextEncoder()

export function encodeText (s: string): Uint8Array {
    const bytes = textEncoder.encode(s)
    return concat([head(3, bytes.length), bytes])
}

export function encodeBytes (bytes: Uint8Array): Uint8Array {
    return concat([head(2, bytes.length), bytes])
}

export function encodeArray (items: Uint8Array[]): Uint8Array {
    return concat([head(4, items.length), ...items])
}
